<template>
    <div class="info-father">
        <div class="index-div-content  product-info-div-no-padding">
            <div>
                <h3 class="margin-bottom-10 center color-1B1B1B font-28 ">
                    <img src="../../assets/img/1.png" width="31" alt=""> <span style="margin:0 20px">产品功能</span>
                    <img
                            src="../../assets/img/2.png" width="31" alt="">
                </h3>
            </div>
            <div class="product_info">
                <div><img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/9.png" width="140" alt=""></div>
                <div><img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/10.png" width="140" alt=""></div>
                <div><img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/11.png" width="140" alt=""></div>
                <div><img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/15.png" width="140" alt=""></div>
                <div><img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/12.png" width="140" alt=""></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductFunction"
    }
</script>

<style scoped>

</style>